import { Popover } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { toobarTheme } from './ToolbarUtils';
import Styles from './FilterPopover.scss';

const SortPopover = ({ id, open, anchorEl, handleClose, item, filterValue, setSortLabel, onChangeFilter, dataCy }) => {
    const onListItemClick = (item) => {
        setSortLabel(item.label);

        let filterData = { ...filterValue };
        filterData.sort.key = item.key;
        filterData.sort.value = item.value;
        onChangeFilter(filterData);
        // setFilterValue(filterData)
        handleClose();
    };

    return (
        <ThemeProvider theme={toobarTheme}>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left' // You can adjust this to control the horizontal position
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left' // You can adjust this to control the horizontal position
                }}
            >
                {/* Your popover content goes here */}
                <div className={Styles.defaultFilterContainer} data-cy={`${dataCy}-sort`}>
                    {item.map((i, index) =>
                        <div className={Styles.filterOptionItem} key={i.key + index.toString()} onClick={() => onListItemClick(i)}>
                            <span>
                                {i.label}
                            </span>
                        </div>
                    )}
                </div>
            </Popover >
        </ThemeProvider>
    );
};

export default SortPopover;